module.exports = __webpack_public_path__ + "static/img/10.a197f12f.png";